import { RequiredValidator } from './required.validator';
import { ValidationResult, ValidatorOptions } from './types.validators';
import { Validator } from './validator';

export class PhoneValidator extends Validator {
    public validate(value: string, options: ValidatorOptions) {
        if (!value) {
            return new RequiredValidator().validate(value, options);
        }

        if (!this.isValidPhone(value)) {
            return new ValidationResult(false, 'Please enter a valid phone number');
        }

        return new ValidationResult(true);
    }

    private isValidPhone(value: string): boolean {
        const phoneRegex = /^\d{10,11}$/;

        return phoneRegex.test(value);
    }
}
